import { render, staticRenderFns } from "./impressao.vue?vue&type=template&id=5d1be8d0&"
import script from "./impressao.vue?vue&type=script&lang=js&"
export * from "./impressao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports